import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { InstacartManagedReportsListPageAccessControl } from './pages/instacart-managed-reports-list/InstacartManagedReportsListPage.configuration'
import { TransactionLogsListPageAccessControl } from './pages/transaction-logs-list/TransactionLogsListPage.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'reports',
  routes,
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'reports-dashboard-tool',
  },
  translations: { EN_US, ES_ES, FR_FR },
  routers: {},
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.AnalyticsReportsAndLogs,
      subNavItems: [
        {
          type: 'item',
          labelId: 'reportsDomain.instacartManagedReportsList.nav',
          route: 'instacart-managed-reports-list',
          accessControl: InstacartManagedReportsListPageAccessControl,
          position: 2,
        },
        {
          type: 'item',
          labelId: 'reportsDomain.transactionLogsList.nav',
          route: 'transaction-logs-list',
          accessControl: TransactionLogsListPageAccessControl,
          position: 4,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
